var map = {
	"./americanexpress.svg": "ca6e",
	"./aura.svg": "43e1",
	"./banescard.svg": "22ef",
	"./boleto.svg": "6eb8",
	"./consulta-ja-logo-colorida.svg": "e068",
	"./consulta-ja-logo-old.svg": "14fc",
	"./consulta-ja-logo.svg": "c6af",
	"./dinersclub.svg": "a3fb",
	"./discover.svg": "3478",
	"./elo.svg": "a7ab",
	"./form_disabled.svg": "4382",
	"./form_enabled.svg": "3fe1",
	"./hiper.svg": "1560",
	"./hipercard.svg": "6bf1",
	"./jcb.svg": "6d0f",
	"./maestro.svg": "08d5",
	"./mastercard.svg": "2dac",
	"./payment-method-boleto.svg": "ca7b",
	"./payment-method-card.svg": "68a3",
	"./payment-method-pix.svg": "8102",
	"./visa.svg": "f73a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";